import Error from "next/error";
import React from "react";
import Head from "next/head";

import LinkYourUPSAccount from "@/components/partners/link-your-ups-account";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

type Props = {
  partner: string;
};

const LinkYourUpsAccountPage = ({ partner }: Props) => {
  if (!partner.includes("ups")) {
    return <Error statusCode={404} title="Page Not Found" />;
  }

  return (
    <>
      <Head>
        <title>{seoData.LINK_UPS_ACCOUNT.title}</title>
        <SeoMetaData data={seoData.LINK_UPS_ACCOUNT} />
      </Head>

      <LinkYourUPSAccount />
    </>
  );
};

export async function getServerSideProps(context: any) {
  const { partner } = context.params;

  return {
    props: { partner }, // will be passed to the page component as props
  };
}

export default LinkYourUpsAccountPage;
